import React from 'react';
import type { FavoriteItemsType, RecentItemsType } from './types.tsx';
import { RenderRecentSection } from './recent-section/index.tsx';
import { RenderStarredSection } from './starred-section/index.tsx';

export const Nav4ProjectsSections = ({
	favoriteItems,
	recentItems,
}: {
	favoriteItems: FavoriteItemsType;
	recentItems: RecentItemsType;
}) => (
	<>
		<RenderStarredSection favoriteItems={favoriteItems} />
		<RenderRecentSection recentItems={recentItems} />
	</>
);
